import { useFeatureFlag } from 'featureFlags/hooks/useFeatureFlag'
import { FC } from 'react'
import { FeatureFlag } from 'shared/enums/FeatureFlag'
import { colors, fonts } from 'shared/lib'
import styled from 'styled-components'
import { t } from 'localization'
import { useShoppingRegionContext } from 'shared/contexts/ShoppingRegionContextProvider'

const TP = 'productTemplate.components.InstantShipCallOut'

const InstantShipWrapper = styled.div``

const CallOut = styled.span`
  ${fonts.SUBTITLE_3};
  color: ${colors.FC2_DARK_GREY};
  margin-right: 5px;
`

const OrderBy = styled.span`
  ${fonts.SUBTITLE_3}
  color: ${colors.FC2_GREY};
`

interface IInstantShipCallOut {
  qaAttr?: string
}

export const InstantShipCallOut: FC<IInstantShipCallOut> = ({ qaAttr }) => {
  const isNextDayHolidayShipping = useFeatureFlag(
    FeatureFlag.TEMP_WEB_FC_HOLIDAY_SHIPPING_2022_NEXT_DAY,
  )
  const isStandardHolidayShipping = useFeatureFlag(
    FeatureFlag.TEMP_WEB_FC_HOLIDAY_SHIPPING_2022_STANDARD,
  )
  const { countryName } = useShoppingRegionContext()

  const getOrderByText = () => {
    if (isStandardHolidayShipping) {
      return t(
        `${TP}.isStandardHolidayShipping`,
        'Order by Dec 19, 2 PM ET for Dec 24 expected delivery. Terms apply.',
      )
    }
    if (isNextDayHolidayShipping) {
      return t(
        `${TP}.isNextDayHolidayShipping`,
        'Expected delivery by Dec 24 with Next Day shipping*',
      )
    }
    if (countryName === 'Japan') {
      return t(
        `${TP}.defaultShippingJP`,
        'Pre-verified and ready to ship from a Flight Club facility',
      )
    }
    return t(
      `${TP}.defaultShipping`,
      // tslint:disable-next-line:max-line-length
      'Order by 2 PM ET for delivery in 3-5 business days or 1 business day with Next Day shipping*',
    )
  }

  return (
    <InstantShipWrapper data-qa={qaAttr}>
      {countryName !== 'Japan' && <CallOut>{t(`${TP}.shipsToday`, 'Ships Today')}</CallOut>}
      <OrderBy>{getOrderByText()}</OrderBy>
    </InstantShipWrapper>
  )
}
